"use client";

import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { checkAuthStatus } from "@/redux/slices/userActions";

export default function AuthInitializer({ children }) {
  const dispatch = useDispatch();
  const { isAuthenticated, loading } = useSelector((state) => state.user);

  useEffect(() => {
    // Check authentication status on app initialization
    // This will fetch user data if authenticated
    dispatch(checkAuthStatus());
  }, [dispatch]);

  // Don't block rendering, let components handle their own loading states
  return children;
}